// hooks/useDevice.js
import { ref, onMounted, onBeforeUnmount } from 'vue'
import isMobile from 'is-mobile'

export function useDevice() {
  const isMobileDevice = ref(isMobile())
  const userAgent = navigator.userAgent
  console.warn(userAgent, 'userAgent')
  const isQuark = /Quark/i.test(userAgent)
  const isHuaweiBrowser = /HuaweiBrowser/i.test(userAgent)

  // 可选：监听 UA 变化（如浏览器模拟设备切换）
  const handleResize = () => {
    isMobileDevice.value = isMobile()
  }

  onMounted(() => window.addEventListener('resize', handleResize))
  onBeforeUnmount(() => window.removeEventListener('resize', handleResize))

  return { isMobileDevice, isQuark, isHuaweiBrowser }
}
